import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faBriefcase } from '@fortawesome/pro-solid-svg-icons';
import './clientMetrics.css'

const ClientMetrics = () => {
  const metrics = [
    {
      number: '+1000',
      label: 'Profesionales',
      icon: faUsers,
      color: '#fb5424',
      bgGradient: 'linear-gradient(135deg, #fb5424 0%, #ff7849 100%)'
    },
    {
      number: '+100',
      label: 'Restaurantes',
      icon: faBuilding,
      color: '#fb5424',
      bgGradient: 'linear-gradient(135deg, #fb5424 0%, #ff7849 100%)'
    },
    {
      number: '+100',
      label: 'Vacantes',
      icon: faBriefcase,
      color: '#fb5424',
      bgGradient: 'linear-gradient(135deg, #fb5424 0%, #ff7849 100%)'
    }
  ];

  return (
    <div className="client-metrics__container">
      <div className="client-metrics__wrapper">
        <div className="client-metrics__grid">
          {metrics.map((metric, index) => (
            <div key={index} className="client-metrics__card">
              <div className="client-metrics__icon-wrapper">
                <FontAwesomeIcon 
                  icon={metric.icon} 
                  className="client-metrics__icon"
                />
              </div>
              <div className="client-metrics__content">
                <div className="client-metrics__number">{metric.number}</div>
                <div className="client-metrics__label">{metric.label}</div>
              </div>
              <div className="client-metrics__decoration"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientMetrics;
